import { cn } from "../../utils/cn";
import * as React from "react";

export const CardSimple = ({
    className,
    children,
    ...props
}: React.HTMLAttributes<HTMLDivElement>) => {

    return (
        <div
            className={cn(
                "bg-background border border-border rounded-xl shadow-card p-4",
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
};

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    title: string;
    category?: string;
    description: string;
    actionLabel?: string;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
    ({ title, category, description, actionLabel = "הורדה", className, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={cn(
                    "rounded-xl border border-border bg-white shadow-card p-6 flex flex-col justify-between min-h-[240px] max-w-sm w-full",
                    className
                )}
                {...props}
            >
                <div className="flex flex-col gap-2">
                    {category && (
                        <span className="text-sm text-gray-500 font-medium">{category}</span>
                    )}
                    <h3 className="text-lg font-semibold text-text-main">{title}</h3>
                    <p className="text-sm text-gray-700">{description}</p>
                </div>

                php-template
                Copy
                Edit
                <button className="mt-6 w-full bg-primary-dark hover:bg-primary-dark/90 text-white py-2.5 rounded-xl text-sm font-semibold transition">
                    {actionLabel}
                </button>
            </div>
        );
    }
);
Card.displayName = "Card";